<template>
  <div class="contact">
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <h1>Contact me via email</h1>
        <a title="Opens your email client" href="mailto:lewismckeownwork@gmail.com?subject=Website%20contact&amp;body=How%20are%20you?" >📧 Lewis Mckeown 📧</a>
      </div>
      <div class="sml-col"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Contact'
  }
</script>
<style scoped>
  .contact {
    text-align: center;
  }
  
  .flex-grid {
  display: flex;
  }
  .col {
    flex: 1;
  }

  @media screen and (max-width: 500px) {
    .flex-grid {
      display: block;
    }
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: space-between;
  }

  .flex-grid-thirds .col {
    width: 32%;
  }

  .flex-grid-thirds .sml-col {
    width: 20%;
    text-align: left;
}
</style>
